import React, { useState, useEffect, useReducer } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import MoreDetailsWindow from './MoreDetailsWindow';
import helper from '../Shared/helper'
import useInterval from '../Shared/UseInterval'

const initialRunData = {
    createdDate: '',
    runtime: '',
    jobID: '',
    expectToProcess: '',
    totalProcessed: '',
    successCount: '...',
    failedCount: '',
    notes: ''
}

const LastRunReport = ({updateJobState}) => {
    const [loading, setLoading] = useState(true);
    const [lastRunData, setLastRunData] = useState(initialRunData);
    const [isRunning, setIsRunning] = useState(true);
    const [jobID, setJobID] = useState(null);
    const [createdDate, setCreatedDate] = useState(null);
    const [showMoreDetails, setShowMoreDetails] = useState(false);
    
    useInterval(() => { 
        if(isRunning) {
            FetchJobDetails() 
        }
    }, 10000);

    useInterval(() => {
        if(isRunning) {
            UpdateRunTime() 
        }
    }, 1000);
    
    useEffect(async()  => {
        await FetchLastRunData()
    }, [])

    useEffect(() => {
        updateJobState(isRunning)
    }, [isRunning])

    const FetchLastRunData = async (totalProcessed, successCount, failedCount) => {
        console.log('fetching last run data')
        api.GetRecentJobSummary()
        .then(JobSummary => processLastJobData(JobSummary, totalProcessed, successCount, failedCount))
        .catch(error => {
            console.log(error) // todo add better logging / error handing
        })
        setLoading(false)
    }

    const FetchJobDetails = async () => {
        console.log('fetching job details')
        api.GetUpdateHistory(jobID)
        .then(details => processJobDetails(details))
        .catch(error => {
            console.log(error) // todo add better logging / error handing
        })
    }
   
    const processLastJobData = (data, totalProcessed, successCount, failedCount) => {
        const notes = helper.checkIfJobIsRunning(data)
        const time = helper.getRuntime(new Date(data.createdDate), new Date(data.processedDate))
        const running = notes === 'Job is currently running'
        if(isRunning != (running)) {
            console.log('updating isRunning to ' + running)
            setIsRunning(running)
        }
        if(jobID !== data.jobID) {
            console.log('updating jobID to ' + data.jobID)
            setJobID(data.jobID) 
        }
        if(createdDate !== data.createdDate) {
            console.log('updating createdDate to ' + data.createdDate)
            setCreatedDate(data.createdDate) 
        }

        setLastRunData([{
            createdDate: new Date(data.createdDate),
            runtime: time,
            jobID: data.jobID,
            expectToProcess: data.expectToProcess,
            totalProcessed: totalProcessed ? totalProcessed : data.totalProcessed,
            successCount: successCount ? successCount : data.successCount,
            failedCount: failedCount ? failedCount : data.failedCount,
            notes: (notes === 'Job is currently running' ||  notes === 'Success' || notes === 'No records found to process') ? notes : 'See Below', 
        }])
    }

    const processJobDetails = (data) => {
        let successCount = 0;
        data.map((record) => {
            if(record.actionDone.trim() !== 'Error' ) {
                successCount++;
            }
        })
        FetchLastRunData(data.length, successCount, data.length - successCount)
    }
    
    const UpdateRunTime = () => {
        if(lastRunData.length && createdDate) {
            const data = lastRunData[0]
            const time = helper.getRuntime(new Date(createdDate), new Date())
            console.log(time)
            setLastRunData([{...data, runtime: time}])
        }
    }

    const closeMoreDetails = () => {
        setShowMoreDetails(false)
    }

    const expandButton = (props) => {
        return (
          <td {...props.tdProps} >
            <button aria-label={`more details for ${props.dataItem.jobID}`} onClick={() => setShowMoreDetails(true)}>+</button>
          </td>
        );
      };

    return (
        <div>
            {showMoreDetails && lastRunData.length && <MoreDetailsWindow jobID={lastRunData[0].jobID} closeWindow={closeMoreDetails} />}
            <h2>Most recent job:</h2>
            {loading ? <><Loader className='spinner-small' size="small" type={"infinite-spinner"} /><em> Loading...</em></> :
                (lastRunData.length ? (
                    <Grid data={lastRunData}>
                        <GridColumn field="" width='60px' title="" cell={expandButton} />
                        <GridColumn field="createdDate" width='230px' title="TimeStamp" format="{0:G}" />
                        <GridColumn field="runtime" width='100px' title="Runtime" className={'runtime-collumn'} />
                        <GridColumn field="jobID" width='100px' title="ID" />
                        <GridColumn field="expectToProcess" width='100px' title="Expected" />
                        <GridColumn field="totalProcessed" width='100px' title="Processed" />
                        <GridColumn field="successCount" width='100px' title="Successes" />
                        <GridColumn field="failedCount" width='100px' title="Failures" />
                        <GridColumn field="notes" title="Notes" />
                    </Grid>
                ) : <p>NO DATA FOUND FOR LAST RUN</p>)
            }
        </div>
    );
};

export default LastRunReport;
